.form-free-trial-type-1 {
  input {
    min-width: 280px;
    max-width: 280px;
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-md);
  }

  &__cell {
    flex: 1 1 0;
    max-width: 100%;

    &--submit {
      flex: 1 1 0;
      max-width: 100%;

      @include desktop {
        flex: 0 0 auto;
      }
    }
  }

  .me-button.form-free-trial-type-1__submit {
    @include below($breakpoint-desktop) {
      max-width: 280px;
    }

    min-height: 49px;
    width: 100%;
  }

  &__input-wrapper {
    position: relative;
    width: 100%;
    z-index: 39;

    .input-wrapper {
      margin-bottom: 0;
    }

    // Hide error message visually when autocomplete is shown, but keep its space to prevent layout shift
    // However, if there's an actual validation error (has-error class), always show it
    &--autocomplete-visible:not(.has-error) {
      .form-error-message {
        visibility: hidden;
        opacity: 0;

        // Keep the space but make it invisible
      }
    }
  }

  &__autocomplete {
    position: absolute;
    left: 0;
    right: 0;
    background: var(--background-color-primary);
    border: var(--border-size-sm) solid var(--border-color-secondary);
    border-radius: var(--radius-size-sm);
    box-shadow: 0 2px 4px rgb(47 55 62 / 15%);
    z-index: 1;
    max-height: 240px;
    overflow-y: auto;
    margin: 0;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transform: translateY(-10px);
    transition:
      opacity 0.2s ease,
      visibility 0s linear 0.2s,
      transform 0.2s ease;
  }

  &__input-wrapper--autocomplete-visible &__autocomplete {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transition-delay: 0s;
    transform: translateY(0);
  }

  &__autocomplete--top {
    border-radius: var(--radius-size-sm) var(--radius-size-sm) 0 0;
    border-top: var(--border-size-sm) solid var(--border-color-secondary);
    border-bottom: none;
  }

  &__autocomplete--bottom {
    border-radius: 0 0 var(--radius-size-sm) var(--radius-size-sm);
    border-top: var(--border-size-sm) solid var(--border-color-secondary);
    border-bottom: none;
  }

  &__autocomplete-item {
    padding: var(--spacing-sm) var(--spacing-md);
    cursor: pointer;
    font-size: map-get($font-sizes, sm);
    color: var(--text-color-primary);
    transition: background-color 0.15s ease;
    font-family: inherit;
    font-weight: map-get($font-weights, normal);
    line-height: var(--spacing-md);
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    background: none;
    margin: 0;

    &:hover,
    &--selected {
      background-color: var(--color-neutral-neutral-lighter);
    }

    &--focused {
      background-color: var(--color-neutral-neutral-lighter);
      outline: none;
    }

    &:first-child {
      border-top-left-radius: var(--radius-size-sm);
      border-top-right-radius: var(--radius-size-sm);
    }

    &:last-child {
      border-bottom-left-radius: var(--radius-size-sm);
      border-bottom-right-radius: var(--radius-size-sm);
    }

    &:focus {
      outline: none;
    }
  }

  &__note {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-xs);
    margin-top: var(--spacing-2xs);
    padding: 0 var(--spacing-xs);
  }

  &__note-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    position: relative;
    bottom: -2px;
    display: block;
  }

  &__note-text {
    font-size: map-get($font-sizes, xs);
    line-height: map-get($line-heights, md);
    text-align: center;
    width: auto;
  }

}

form-free-trial-type-1[mobile-layout="stacked"] {
  @include below($breakpoint-desktop) {
    .form-free-trial-type-1__row {
      flex-direction: column;
    }

    .form-free-trial-type-1__cell {
      flex: none;
      width: 100%;
      max-width: 100%;
    }

    .form-free-trial-type-1__cell--submit {
      width: 100%;
    }

    .me-input,
    .form-free-trial-type-1__submit {
      width: 100%;
    }
  }
}
